/**
 * Detects whether a job title is likely an eligible R&D / technical role
 * for tax credit and grant matching (e.g. SR&ED).
 */
const RD_TITLE_PATTERNS = [
  /\bcto\b/i,
  /\bchief\s+technology\b/i,
  /\bvp\b.*\b(engineering|technology|product|research|r\s*&\s*d)\b/i,
  /\bvice\s+president\b.*\b(engineering|technology|product|research|r\s*&\s*d)\b/i,
  /\bhead\s+of\b.*\b(engineering|technology|product|research|r\s*&\s*d)\b/i,
  /\bdirector\b.*\b(engineering|technology|product|research|r\s*&\s*d)\b/i,
  /\b(software|hardware|firmware|platform|systems?|data|ml|ai|devops|security|qa|test|frontend|backend|full[\s-]?stack|mobile|cloud|infrastructure)\s+(engineer|developer|architect)\b/i,
  /\b(engineer|engineering)\b/i,
  /\b(developer|programmer)\b/i,
  /\b(architect)\b/i,
  /\b(scientist|researcher)\b/i,
  /\bresearch\b/i,
  /\btechnolog(y|ies|ist)\b/i,
  /\br\s*&\s*d\b/i,
  /\bmachine\s+learning\b/i,
  /\bartificial\s+intelligence\b/i,
  /\bdata\s+(scientist|engineer|analyst)\b/i,
  /\bdevops\b/i,
  /\bsite\s+reliability\b/i,
  /\bproduct\s+(manager|owner)\b/i,
  /\btechnical\s+(lead|director|program)\b/i,
  /\bstaff\s+(engineer|developer)\b/i,
  /\bprincipal\s+(engineer|developer|scientist)\b/i,
];

export function isLikelyRdTitle(title) {
  if (!title || typeof title !== "string") return false;
  const normalized = title.trim();
  if (!normalized) return false;
  return RD_TITLE_PATTERNS.some((pattern) => pattern.test(normalized));
}

export function getRdMatchLabel(title) {
  return isLikelyRdTitle(title) ? "Likely R&D" : "Not R&D";
}
